import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctors-station-oem-register-message',
  templateUrl: './doctors-station-oem-register-message.component.html',
  styleUrls: [
    './doctors-station-oem-register-message.component.css',
    '../style/global.css',
  ],
})
export class DoctorsStationOemRegisterMessageComponent implements OnChanges {
  pref: string;
  @Input()
  clientId: string;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.clientId);

    this.pref = environment.apps[this.clientId].oemConfig?.pref;
  }

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }
}
